import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Form } from "react-form";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import CreateIcon from "@material-ui/icons/Create";
import AppContainer from "../common/AppContainer";
import PageHeader from "../common/PageHeader";
import EnhancedTableHead from "../common/EnhancedTableHead";
import CustomTableCell from "../common/TableCell";
import TextField from "../common/TextField";
import TablePaginationActionsWrapped from "../common/Paginator";
import { createSelector } from "../common/orm";
import { User } from "../home/models";

const styles = theme => ({
    table: {
        width: "100%",
        "& tbody tr:nth-child(even)": {
            backgroundColor: "#ffeff2"
        }
    },
    nowrap: {
        whiteSpace: "nowrap"
    },
    deleteWidth: {
        minWidth: 32,
        width: 32,
        height: 32,
        marginRight: 8,
    },
    centerAlign: {
        textAlign: "center"
    }
});

const getUsers = createSelector(schema => {
    return schema.User.all()
        .orderBy("name", "asc")
        .toRefArray();
});

const columnDataUsers = [
    { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" },
    { id: "id", numeric: true, label: "ID", allowSort: true },
    { id: "name", numeric: false, label: "Name", allowSort: true },
    { id: "email", numeric: false, label: "Email", allowSort: true },
    { id: "date_joined_label", numeric: false, label: "Date Registered", allowSort: true, date: true },
    { id: "last_login_label", numeric: false, label: "Last Login Date", allowSort: true, date: true }
];

class Users extends Component {
    state = {
        page: 0,
        rowsPerPage: 25,
        order: "asc",
        orderBy: "name",
        filter: null
    };

    componentDidMount() {
        document.title = "Manage Users - LSOHC Proposal and Grant Management System";
        const { authState, history, ormUserReload } = this.props;
        if (authState && authState.user && authState.user.role !== "admin") {
            history.push("/dashboard");
        }
        if (authState && authState.user && authState.user.role === "admin") {
            ormUserReload();
        }
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        this.props.users.sort(function(a, b) {
            var date = columnDataUsers.find(cD => cD.id === orderBy).date;
            var numeric = columnDataUsers.find(cD => cD.id === orderBy).numeric;
            if (date) {
                if (order === "desc") return new Date(b[orderBy]) < new Date(a[orderBy]) ? -1 : 1;
                else return new Date(a[orderBy]) < new Date(b[orderBy]) ? -1 : 1;
            } else if (numeric) {
                if (order === "desc") return parseFloat(b[orderBy]) < parseFloat(a[orderBy]) ? -1 : 1;
                else return parseFloat(a[orderBy]) < parseFloat(b[orderBy]) ? -1 : 1;
            } else {
                if (order === "desc")
                    return (b[orderBy] || "").toUpperCase() < (a[orderBy] || "").toUpperCase() ? -1 : 1;
                else return (a[orderBy] || "").toUpperCase() < (b[orderBy] || "").toUpperCase() ? -1 : 1;
            }
        });

        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value, page: 0 });
    };

    filterByValue = (array, string) => {
        return array.filter(o =>
            Object.keys(o).some(
                k =>
                    o[k] &&
                    o[k]
                        .toString()
                        .toLowerCase()
                        .includes(string.toLowerCase())
            )
        );
    };

    render() {
        const { users, classes } = this.props;
        const { page, rowsPerPage, order, orderBy, filter } = this.state;

        var filtered_users;
        if (filter) {
            filtered_users = this.filterByValue(users, filter);
        } else {
            filtered_users = users;
        }

        return (
            <AppContainer authenticated>
                <Grid container spacing={2}>
                    <PageHeader title="Manage Users" />
                    <Grid item xs={12}>
                        <Form dontValidateOnMount={true} validateOnSubmit={true}>
                            {formApi => (
                                <form style={{ float: "right" }} onSubmit={formApi.submitForm}>
                                    <TextField
                                        eventHandle={val => this.setState({ filter: val })}
                                        field="filter"
                                        label="Filter"
                                        filterInput
                                    />
                                </form>
                            )}
                        </Form>
                        <Table className={classes.table}>
                            <EnhancedTableHead
                                columnData={columnDataUsers}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                            />
                            <TableBody>
                                {filtered_users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    return (
                                        <TableRow hover key={n.id}>
                                            <CustomTableCell className={classes.nowrap}>
                                                <Tooltip title="Edit User">
                                                    <Button
                                                        color="primary"
                                                        className={classes.deleteWidth}
                                                        component={Link}
                                                        to={"/adm/users/" + n.id}>
                                                        <CreateIcon color="primary" />
                                                    </Button>
                                                </Tooltip>
                                            </CustomTableCell>
                                            <CustomTableCell>{n.id}</CustomTableCell>
                                            <CustomTableCell>{n.name}</CustomTableCell>
                                            <CustomTableCell>{n.email}</CustomTableCell>
                                            <CustomTableCell>{n.date_joined_label}</CustomTableCell>
                                            <CustomTableCell>{n.last_login_label}</CustomTableCell>
                                        </TableRow>
                                    );
                                })}
                                {filtered_users.length < 1 && (
                                    <TableRow>
                                        <CustomTableCell colSpan={6} className={classes.centerAlign}>
                                            No Users Found
                                        </CustomTableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                            {filtered_users.length > 25 && (
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            colSpan={6}
                                            count={filtered_users.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </TableRow>
                                </TableFooter>
                            )}
                        </Table>
                    </Grid>
                </Grid>
            </AppContainer>
        );
    }
}

Users = connect(
    (state, ownProps) => ({
        authState: state.auth,
        users: getUsers(state, ownProps)
    }),
    {
        ...User.actions
    }
)(Users);

export default withStyles(styles)(withRouter(Users));
